<template>
  <router-view />
</template>

<script>
export default {
  name: 'Medias'
}
</script>
